module.exports = __webpack_public_path__ + "media/images/gallery-image9-16822816ae6815ade85483379984d228.webp";